module.exports = __webpack_public_path__ + "static/media/02.25cad79e.mp3";